module.exports = "/assets/home-page/media/vogue.png?q38OIVX";